export default [
  {value: 1, name: '主菜单'},
  {value: 2, name: '操作菜单'}
]